import './GetInTouch.scss';
import Form from '../Form/Form';

const GetInTouch = () => {
    return(
        <section className='arta-getintouch'>
            <div className='arta-container'>
                <div className='arta-getintouch__wrapper'>
                    <div className='arta-getintouch__wrapper--left'>
                        <h3 className="arta-latin-text">
                        Wanna be one of our satisfied clients? Reach out today and let’s start building something amazing together.
                        </h3>

                         <img
                            src={require("../../assets/gifs/mail.gif")}
                            alt="Artacode Digital Agency"
                        />
                    </div>
                    <div className='arta-getintouch__wrapper--right'>
                        <Form />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default GetInTouch;